import React from 'react';
import { render } from 'react-dom';
import { Inertia } from '@inertiajs/inertia';
import { InertiaApp } from '@inertiajs/inertia-react';
import * as Sentry from '@sentry/browser';
import GeneralLayout from '@/Shared/Layouts/GeneralLayout';
import IntranetLayout from '@/Shared/Layout';
import { InertiaProgress } from '@inertiajs/progress'

import { config } from '@fortawesome/fontawesome-svg-core'
//import '@fortawesome/fontawesome-svg-core/styles.css' // Import the CSS
config.autoAddCss = false // Tell Font Awesome to skip adding the CSS automatically since it's being imported above

Sentry.init({
  dsn: process.env.MIX_SENTRY_LARAVEL_DSN
});

//import '../sass/vendor.scss'

//import '../sass/main.scss'
import { Auth } from '@/constants/models/User';

const app = document.getElementById('app');

//require('dotenv').config();
InertiaProgress.init()

if (!window?.InertiaApp && process.env.MIX_APP_ENV!=='production') window.Inertia = Inertia; 

const placeholder = document.getElementById('base_app');

//if (placeholder) app.appendChild(placeholder);

function deferIframe() {
  var iframeElem = document.getElementsByTagName('iframe');
  for ( var i = 0; i < iframeElem.length; i++ ) {
    if(iframeElem[i].getAttribute('data-src')) {
      iframeElem[i].setAttribute('src',iframeElem[i].getAttribute('data-src'));
    } 
  } 
}

window.onload = deferIframe;

let last_layout;

render(
  <InertiaApp
    initialPage={JSON.parse(app.dataset.page)}
    resolveComponent={name =>
      import(`./Pages/${name}`).then(({default: page}) => {
      	if (page.layout === undefined) {
          const isIntranet = location.pathname.startsWith("/intranet/");
          if (!(name.startsWith('Dashboard/')||name.startsWith('Users/')||
            name.startsWith('Intranet/')||name.startsWith('Catalogo/')||name.startsWith('Error')
          )) {
            page.layout = pagina => <GeneralLayout children={pagina} />
          } else if (page.with_last_layout && last_layout) {
            page.layout = last_layout;
          }
          if (page.layout === undefined && page.with_last_layout && isIntranet) {
            page.layout = pagina => <IntranetLayout children={pagina} />
          }
        }
        if (typeof page.layout == 'function') last_layout = page.layout;
		if (placeholder?.innerHTML) placeholder.innerHTML = "";
		return page
      })
    }
    transformProps={(props)=>{
      return {...props, auth: new Auth(props.auth)}
    }}
  />,
  app
);
